// client/src/pages/ForgotPasswordPage.js
import React, { useState } from 'react';
import {
  Form, Button, Card, Spinner, Row, Col, Image, Alert
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../assets/logo-c.png';

// Use the environment variable for the API root URL
const API_ROOT_URL = process.env.REACT_APP_API_ROOT_URL;

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    // Check if the API URL is defined
    if (!API_ROOT_URL) {
      setError('Server configuration error. Please try again later.');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_ROOT_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      // The backend sends a generic success message to prevent email enumeration.
      // We will display this message regardless of the actual outcome.
      const result = await response.json();
      setMessage(result.message || 'If a user with that email exists, a password reset link has been sent.');

    } catch (err) {
      console.error('Error in forgot password request:', err);
      setError('Failed to connect to the server. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-vh-100 d-flex flex-column justify-content-center align-items-center p-3"
      style={{ background: 'linear-gradient(#4594ad, white, white)' }}
    >
      {/* Logo + Branding */}
      <div className="text-center mb-0 mt-0">
        <Image
          src={logo}
          alt="Company Logo"
          className="mb-3 img-fluid"
          style={{ maxWidth: '250px', height: 'auto' }}
        />
        <h1 className="mt-5 mb-0 text-black ">Touchless Tracking</h1>
      </div>

      {/* Forgot Password Card */}
      <Card className="p-4 mt-4 shadow rounded border" style={{ maxWidth: '450px', width: '100%' }}>
        <Card.Body>
          <h4 className="text-center mb-4">Forgot Password</h4>

          <Form onSubmit={handleSubmit}>
            <p className="text-center text-muted">
              Enter your email address to receive a password reset link.
            </p>
            <Form.Group className="mb-3" controlId="formForgotPasswordEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                required
              />
            </Form.Group>

            {message && (
              <Alert variant="success" className="text-center">
                {message}
              </Alert>
            )}
            {error && (
              <Alert variant="danger" className="text-center">
                {error}
              </Alert>
            )}

            <Button
              variant="primary"
              type="submit"
              className="w-100 mt-3 fw-bold"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  <span className="ms-2">Sending link...</span>
                </>
              ) : (
                'Send Reset Link'
              )}
            </Button>
          </Form>

          <Row className="mt-4">
            <Col className="text-center">
              <small>
                Remember your password?{' '}
                <Link to="/" className="fw-bold text-decoration-none">Login</Link>
              </small>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ForgotPasswordPage;
